import React from "react";
import { useTheme } from "@/contexts/ThemeContext";
import { Moon, Sun } from "lucide-react";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      className="btn-sharp inline-flex items-center gap-1.5 border border-border bg-card hover:bg-muted px-2 py-1 text-[10px] uppercase tracking-wider"
      aria-label="Toggle theme"
    >
      {theme === "dark" ? <Sun className="h-3 w-3 text-primary" /> : <Moon className="h-3 w-3 text-primary" />}
      <span className="mono">{theme}</span>
    </button>
  );
}
